import { useState } from 'react';

import styled from 'styled-components';
import AllSwitch from './AllSwitch';
import ConfirmModal from '../../ConfirmModal';

export default function ControlAll({
  isOn,
  setIsOn,
}: {
  isOn: boolean;
  setIsOn: (value: boolean) => void;
}) {
  const [modalState, setModalState] = useState(false);
  const [nextValue, setNextValue] = useState(true);

  const handleClick = (value: boolean) => {
    setNextValue(value);
    setModalState(true);
  };

  const handleConfirm = () => {
    setIsOn(nextValue);
    setModalState(false);
  };

  const handleCancel = () => {
    setModalState(false);
  };
  return (
    <>
      <SwitchContainer>
        <SwitchTitle>주차장 혼잡도</SwitchTitle>
        <AllSwitch isOn={isOn} setIsOn={value => handleClick(value)} />
      </SwitchContainer>
      <ConfirmModal
        isOpen={modalState}
        title="주차장 혼잡도"
        description={`주차장 혼잡도 표시를 ${nextValue ? '켜' : '끄'}시겠습니까?`}
        confirmText={nextValue ? '켜기' : '끄기'}
        confirmColor={nextValue ? 'blue' : 'red'}
        onConfirm={handleConfirm}
        onCancel={handleCancel}
      />
    </>
  );
}

const SwitchContainer = styled.div`
  width: 100%;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 17px 20px;
  background: #fff;
  margin-bottom: 4px;
`;
const SwitchTitle = styled.div`
  color: var(--Font-02_black, #111);
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 26px; /* 130% */
  letter-spacing: -0.5px;
`;
